import { Breadcrumbs, Link as MuiLink, Typography } from "@mui/material";
import { NavigateNext } from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";

const routes = [
  { match: (path) => path === "/characters", items: [{ label: "Character library" }] },
  { match: (path) => path === "/dashboard", items: [{ label: "Courses" }] },
  { match: (path) => path === "/review-voice-notes", items: [{ label: "Voice notes" }] },
  { match: (path) => path.startsWith("/voice-notes/"), items: [{ label: "Voice notes", to: "/review-voice-notes" }, { label: "Course review" }] },
  { match: (path) => path === "/review-upgraded-lar", items: [{ label: "Upgraded LAR" }] },
  { match: (path) => path.startsWith("/upgraded-lar/"), items: [{ label: "Upgraded LAR", to: "/review-upgraded-lar" }, { label: "Course review" }] },
  { match: (path) => path === "/review-ai-feedbacks", items: [{ label: "AI feedback" }] },
  { match: (path) => path.startsWith("/ai-feedbacks/"), items: [{ label: "AI feedback", to: "/review-ai-feedbacks" }, { label: "Course review" }] },
  { match: (path) => path.startsWith("/edit/"), items: [{ label: "Courses", to: "/dashboard" }, { label: "Course editor" }] },
  { match: (path) => path.startsWith("/course-detail/"), items: [{ label: "Courses", to: "/dashboard" }, { label: "Course details" }] },
  { match: (path) => path.includes("/add-unit"), items: [{ label: "Courses", to: "/dashboard" }, { label: "Add unit" }] },
  { match: (path) => path.includes("/add-level"), items: (path) => unitItems(path, "Add level") },
  { match: (path) => path.includes("/units/") && path.endsWith("/edit"), items: (path) => unitItems(path, "Unit editor") },
  { match: (path) => path.includes("/units/") && path.endsWith("/view"), items: (path) => unitItems(path, "Unit details") },
  { match: (path) => path === "/create-course", items: [{ label: "Courses", to: "/dashboard" }, { label: "Create course" }] },
  { match: (path) => path === "/upload-course", items: [{ label: "Courses", to: "/dashboard" }, { label: "Import course" }] },
];

const unitItems = (path, current) => {
  const courseId = path.match(/^\/course\/([^/]+)/)?.[1];
  return [
    { label: "Courses", to: "/dashboard" },
    { label: "Curriculum", to: `/edit/${courseId}?tab=curriculum` },
    { label: current },
  ];
};

const PortalBreadcrumbs = () => {
  const { pathname } = useLocation();
  const route = routes.find((item) => item.match(pathname));
  const items =
    typeof route?.items === "function" ? route.items(pathname) : route?.items;
  if (!items) return null;
  return (
    <Breadcrumbs
      separator={<NavigateNext fontSize="small" />}
      aria-label="breadcrumb"
      sx={{ mb: 2, "& .MuiBreadcrumbs-ol": { alignItems: "center" } }}
    >
      {items.map((item, index) =>
        item.to && index < items.length - 1 ? (
          <MuiLink
            key={item.label}
            component={Link}
            underline="hover"
            color="inherit"
            to={item.to}
          >
            {item.label}
          </MuiLink>
        ) : (
          <Typography key={item.label} color="text.secondary" variant="body2">
            {item.label}
          </Typography>
        ),
      )}
    </Breadcrumbs>
  );
};

export default PortalBreadcrumbs;
